module.exports = __webpack_public_path__ + "img/sample3-voronoi-inverse-high.1ac827c2.png";